import React from 'react';
import {
  StandardInputBaseProps,
  inputContainerStyles,
  labelStyles,
  requiredIndicatorStyles,
  getInputClassName,
} from './StandardInputStyles';

interface Props extends StandardInputBaseProps {
  min?: number;
  max?: number;
  onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
}

export default function StandardInputNumber({
  id,
  label,
  isRequired,
  placeholderText,
  min,
  max,
  value,
  onChange,
}: Props) {
  return (
    <div className={inputContainerStyles}>
      <label htmlFor={id} className={labelStyles}>
        {label}
        {isRequired && <span className={requiredIndicatorStyles}>*</span>}
      </label>
      <input
        type='number'
        id={id}
        placeholder={placeholderText ?? ''}
        className={getInputClassName('number')}
        min={min}
        max={max}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}
